import { createApi } from '@reduxjs/toolkit/query/react';

import { interceptor } from 'services/interceptor';
import { CompanySearchParams, ProgAISearchCompanyResult, ProgAISearchCompanyCount } from 'shared/generated-models';

export const companySearchService = createApi({
	reducerPath: 'companySearchService',
	baseQuery: interceptor,
	tagTypes: ['CompanySearch', 'CompanyCount'],
	endpoints: builder => ({
		getCompanyCandidates: builder.query<ProgAISearchCompanyResult, CompanySearchParams>({
			query: params => ({
				url: '/technographics/',
				method: 'POST',
				body: params,
				invalidatesTags: ['CompanySearch']
			})
		}),
		getCompanyCount: builder.query<ProgAISearchCompanyCount, CompanySearchParams>({
			query: params => ({
				url: '/technographics/count/',
				method: 'POST',
				body: params,
				invalidatesTags: ['CompanyCount']
			})
		})
	})
});

export const {
	useGetCompanyCandidatesQuery,
	useGetCompanyCountQuery,
	usePrefetch: useTechnographicsPrefetch
} = companySearchService;
